import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
export const getEls = (self) => {
  self._checkNoProcessingTask();
  return Array.from(self._els.values());
};
